import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {AuthGuard} from '../admin/auth/auth.guard';

const routes: Routes = [
  {
    path: 'expert-tabs',
    redirectTo: 'appointment',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_EXPERT'
    }
  },
  {
    path: '',
    loadChildren: () => import('./expert-tabs/expert-tabs.module').then(m => m.ExpertTabsPageModule)
  },
  {
    path: 'expert-settings',
    loadChildren: () => import('./expert-settings/expert-settings.module').then( m => m.ExpertSettingsPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_EXPERT'
    }
  },
  {
    path: 'expert-profile',
    loadChildren: () => import('./expert-profile/expert-profile.module').then( m => m.ExpertProfilePageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_EXPERT'
    }
  },
  {
    path: 'dashboard2',
    loadChildren: () => import('./expert-account/expert-account.module').then( m => m.ExpertAccountPageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_EXPERT'
    }
  },
  {
    path: 'expert-social-media-modal',
    loadChildren: () =>
    import('./expert-social-media-modal/expert-social-media-modal.module').then( m => m.ExpertSocialMediaModalPageModule)
  },
  {
    path: 'expert-hobbies-modal',
    loadChildren: () =>
    import('./expert-hobbies-modal/expert-hobbies-modal.module').then( m => m.ExpertHobbiesModalPageModule)
  },
  {
    path: 'expert-calendar-off-day-page',
    loadChildren: () =>
    import('./expert-calendar-off-day/expert-calendar-off-day.module').then( m => m.ExpertCalendarOffDayPageModule)
  },
  {
    path: 'expert-education',
    loadChildren: () =>
    import('./expert-education/expert-education.module').then( m => m.ExpertEducationPageModule)
  },
  {
    path: 'expert-services-modal',
    loadChildren: () =>
    import('./expert-services-modal/expert-services-modal.module').then( m => m.ExpertServicesModalPageModule)
  },
  {
    path: 'expert-teammates-modal',
    loadChildren: () =>
    import('./expert-teammates-modal/expert-teammates-modal.module').then( m => m.ExpertTeammatesModalPageModule)
  },
  {
    path: 'expert-awards-modal',
    loadChildren: () =>
    import('./expert-awards-modal/expert-awards-modal.module').then( m => m.ExpertAwardsModalPageModule)
  },
  {
    path: 'expert-publication-modal',
    loadChildren: () =>
    import('./expert-publication-modal/expert-publication-modal.module').then( m => m.ExpertPublicationModalPageModule)
  },
  {
    path: 'expert-experiences-modal',
    loadChildren: () => import('./expert-experiences-modal/expert-experiences-modal.module').then( m => m.ExpertExperiencesModalPageModule)
  },
  {
    path: 'expert-languages-modal',
    loadChildren: () => import('./expert-languages-modal/expert-languages-modal.module').then( m => m.ExpertLanguagesModalPageModule)
  },
  {
    path: 'expert-article-list-modal',
    loadChildren: () =>
    import('./expert-article-list-modal/expert-article-list-modal.module').then( m => m.ExpertArticleListModalPageModule)
  },
  {
    path: 'expert-article-detail-modal',
    loadChildren: () =>
    import('./expert-article-detail-modal/expert-article-detail-modal.module').then( m => m.ExpertArticleDetailModalPageModule)
  },
  {
    path: 'expert-article-add-modal',
    loadChildren: () => import('./expert-article-add-modal/expert-article-add-modal.module').then( m => m.ExpertArticleAddModalPageModule)
  },
  {
    path: 'expert-article-update-modal',
    loadChildren: () =>
    import('./expert-article-update-modal/expert-article-update-modal.module').then( m => m.ExpertArticleUpdateModalPageModule)
  },
  {
    path: 'expert-clinic-contact-modal',
    loadChildren: () =>
    import('./expert-clinic-contact-modal/expert-clinic-contact-modal.module').then( m => m.ExpertClinicContactModalPageModule)
  },
  {
    path: 'expert-clinic-images-modal',
    loadChildren: () =>
    import('./expert-clinic-images-modal/expert-clinic-images-modal.module').then( m => m.ExpertClinicImagesModalPageModule)
  },
  {
    path: 'expert-clinic-insurances-modal',
    loadChildren: () =>
    import('./expert-clinic-insurances-modal/expert-clinic-insurances-modal.module').then( m => m.ExpertClinicInsurancesModalPageModule)
  },
  {
    path: 'expert-clinic-services-modal',
    loadChildren: () =>
    import('./expert-clinic-services-modal/expert-clinic-services-modal.module').then( m => m.ExpertClinicServicesModalPageModule)
  },
  {
    path: 'expert-clinic-facilities-modal',
    loadChildren: () =>
    import('./expert-clinic-facilities-modal/expert-clinic-facilities-modal.module').then( m => m.ExpertClinicFacilitiesModalPageModule)
  },
  {
    path: 'expert-profile-branches-modal',
    loadChildren: () =>
    import('./expert-profile-branches-modal/expert-profile-branches-modal.module').then( m => m.ExpertProfileBranchesModalPageModule)
  },
  {
    path: 'expert-profile-interests-modal',
    loadChildren: () =>
    import('./expert-profile-interests-modal/expert-profile-interests-modal.module').then( m => m.ExpertProfileInterestsModalPageModule)
  },
  {
    path: 'expert-profile-medical-group-modal',
    loadChildren: () =>
    import('./expert-profile-medical-group-modal/expert-profile-medical-group-modal.module')
    .then( m => m.ExpertProfileMedicalGroupModalPageModule)
  },
  {
    path: 'expert-profile-branch-services-modal',
    loadChildren: () =>
    import('./expert-profile-branch-services-modal/expert-profile-branch-services-modal.module')
    .then( m => m.ExpertProfileBranchServicesModalPageModule)
  },
  {
    path: 'expert-rates-modal',
    loadChildren: () => import('./expert-rates-modal/expert-rates-modal.module').then( m => m.ExpertRatesModalPageModule)
  },
  {
    path: 'expert-announcement-modal',
    loadChildren: () => import('./expert-announcement-modal/expert-announcement-modal.module')
    .then( m => m.ExpertAnnouncementModalPageModule)
  },
  {
    path: 'expert-groups-modal',
    loadChildren: () => import('./expert-groups-modal/expert-groups-modal.module').then( m => m.ExpertGroupsModalPageModule)
  },
  {
    path: 'expert-branches-modal',
    loadChildren: () => import('./expert-branches-modal/expert-branches-modal.module').then( m => m.ExpertBranchesModalPageModule)
  },
  {
    path: 'expert-interests-modal',
    loadChildren: () => import('./expert-interests-modal/expert-interests-modal.module').then( m => m.ExpertInterestsModalPageModule)
  },
  {
    path: 'expert-branch-choose-layer-modal',
    loadChildren: () =>
    import('./expert-branch-choose-layer-modal/expert-branch-choose-layer-modal.module')
    .then( m => m.ExpertBranchChooseLayerModalPageModule)
  },
  {
    path: 'expert-interest-layer-group-modal',
    loadChildren: () =>
    import('./expert-interest-layer-group-modal/expert-interest-layer-group-modal.module')
    .then( m => m.ExpertInterestLayerGroupModalPageModule)
  },
  {
    path: 'expert-interest-layer-branch-modal',
    loadChildren: () =>
    import('./expert-interest-layer-branch-modal/expert-interest-layer-branch-modal.module')
    .then( m => m.ExpertInterestLayerBranchModalPageModule)
  },
  {
    path: 'expert-branch-service-modal',
    loadChildren: () =>
    import('./expert-branch-service-modal/expert-branch-service-modal.module')
    .then( m => m.ExpertBranchServiceModalPageModule)
  },
  {
    path: 'expert-branch-service-group-layer-modal',
    loadChildren: () =>
    import('./expert-branch-service-group-layer-modal/expert-branch-service-group-layer-modal.module')
    .then( m => m.ExpertBranchServiceGroupLayerModalPageModule)
  },
  {
    path: 'expert-branch-service-branch-layer-modal',
    loadChildren: () =>
    import('./expert-branch-service-branch-layer-modal/expert-branch-service-branch-layer-modal.module')
    .then( m => m.ExpertBranchServiceBranchLayerModalPageModule)
  },
  {
    path: 'expert-calendar-modal',
    loadChildren: () => import('./expert-calendar-modal/expert-calendar-modal.module').then( m => m.ExpertCalendarModalPageModule)
  },
  {
    path: 'expert-appointments',
    loadChildren: () => import('./expert-appointments/expert-appointments.module').then( m => m.ExpertAppointmentsPageModule)
  },
  {
    path: 'expert-appointments-per-days',
    loadChildren: () =>
    import('./expert-appointments-per-days/expert-appointments-per-days.module').then( m => m.ExpertAppointmentsPerDaysPageModule)
  },
  {
    path: 'expert-appointment-detail-modal',
    loadChildren: () =>
    import('./expert-appointment-detail-modal/expert-appointment-detail-modal.module').then( m => m.ExpertAppointmentDetailModalPageModule)
  },
  {
    path: 'expert-appointment-settings-modal',
    loadChildren: () =>
    import('./expert-appointment-settings-modal/expert-appointment-settings-modal.module')
    .then( m => m.ExpertAppointmentSettingsModalPageModule)
  },
  {
    path: 'expert-question-detail',
    loadChildren: () => import('./expert-question-detail/expert-question-detail.module').then( m => m.ExpertQuestionDetailModule)
  },
  {
    path: 'expert-video-modal',
    loadChildren: () => import('./expert-video-modal/expert-video-modal.module').then( m => m.ExpertVideoModalPageModule)
  },
  {
    path: 'expert-calendar-off-day',
    loadChildren: () => import('./expert-calendar-off-day/expert-calendar-off-day.module').then( m => m.ExpertCalendarOffDayPageModule)
  },
  {
    path: 'expert-add-patient',
    loadChildren: () => import('./expert-add-patient/expert-add-patient.module').then( m => m.ExpertAddPatientPageModule)
  },
  {
    path: 'expert-patients',
    loadChildren: () => import('./expert-patients/expert-patients.module').then( m => m.ExpertPatientsPageModule)
  },
  {
    path: 'expert-patient-detail',
    loadChildren: () => import('./expert-patient-detail/expert-patient-detail.module').then( m => m.ExpertPatientDetailPageModule)
  },
  {
    path: 'choose-location',
    loadChildren: () => import('./choose-location/choose-location.module').then( m => m.ChooseLocationPageModule)
  },
  {
    path: 'call-details',
    loadChildren: () => import('./call-details/call-details.module').then( m => m.CallDetailsPageModule)
  },
  {
    path: 'expert-video-chat',
    loadChildren: () => import('./video-chat/video-chat.module').then( m => m.VideoChatPageModule)
  },
  {
    path: 'choose-location-modal',
    loadChildren: () => import('./choose-location-modal/choose-location-modal.module').then( m => m.ChooseLocationModalPageModule)
  },
  {
    path: 'expert-chatscreen',
    loadChildren: () => import('./chatscreen/chatscreen.module').then( m => m.ChatscreenPageModule)
  },

  // { path: '', redirectTo:'dashboard2', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExpertRoutingModule {}
